<script>
import Layout from '@layouts/main.vue'
import { authMethods } from '@state/helpers'
import analyticsService from '@utils/analytics-service'

export default {
  page: {
    title: 'Sign Up',
    meta: [
      {
        name: 'description',
        content: `Sign Up for Inventory Bot. Start tracking products today!`,
      },
    ],
  },
  components: { Layout },
  data() {
    return {
      username: '',
      password: '',
      registerError: null,
      tryingToRegister: false,
    }
  },
  computed: {
    placeholders() {
      return {
        username: 'E-mail Address',
        password: 'Password',
      }
    },
  },
  mounted() {
    analyticsService.trackPageView('Sign Up')
  },
  methods: {
    ...authMethods,
    tryToRegister() {
      this.tryingToRegister = true
      // Reset the authError if it existed.
      this.registerError = null
      return this.register({
        username: this.username,
        password: this.password,
      })
        .then((token) => {
          // Redirect to the originally requested page, or to the home page
          this.$router.push({ name: 'profile' })
        })
        .catch((error) => {
          this.registerError = error.response.data.error
        })
        .finally(() => {
          this.tryingToRegister = false
        })
    },
  },
}
</script>

<template>
  <Layout>
    <div :class="$style.container">
      <div>
        <h2
          >Join us on the IB App!<br />You can now find us on the App Store and
          Google Play!</h2
        >
      </div>
      <br />
      <br />
      <br />

      <div>
        <a href="https://apps.apple.com/tm/app/inventory-bot/id1599747004">
          <img
            src="https://inventorybot.io/wp-content/uploads/2021/07/btn2.png"
          />
        </a>
      </div>
      <br />
      <div>
        <a
          href="https://play.google.com/store/apps/details?id=io.inventorybot.app"
        >
          <img
            src="https://inventorybot.io/wp-content/uploads/2021/07/btn1.png"
          />
        </a>
      </div>
    </div>
  </Layout>
</template>

<style lang="scss" module>
@import '@design';

.container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  text-align: center;
}
</style>
